/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetAssetByIdOptions, GetAssetByIdResponses } from '../types/GetAssetById'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get asset by ID
 * {@link /v1/assets/:asset_id}
 */
export function getAssetById<ThrowOnError extends boolean = true>(
  options: Options<GetAssetByIdOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetAssetByIdResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/assets/{asset_id}',
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetAssetByIdResponses, ThrowOnError>>,
  )
}
